import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../state/useAuth';

export default function ProtectedRoute({ requireAdmin = false, allowedRoles = null }){
  const { isLogged, isAdmin, role } = useAuth();
  if (!isLogged) return <Navigate to="/" replace />;
  if (requireAdmin && !isAdmin) return <Navigate to="/" replace />;
  if (Array.isArray(allowedRoles) && allowedRoles.length > 0){
    if (!allowedRoles.includes(role)) return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
